import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "shadow-md bg-white flex rounded-xl overflow-hidden m-2" }
const _hoisted_2 = { class: "py-6 w-1/6 flex flex-col justify-center items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "opacity-60" }, "Answers", -1)
const _hoisted_4 = { class: "py-6 w-4/6" }
const _hoisted_5 = ["dir"]
const _hoisted_6 = { class: "flex ml-2 my-2" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "w-6 h-6 mr-2 rounded-full overflow-hidden shadow-lg flex justify-center items-center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "text-blue-800 font-bold cursor-pointer" }
const _hoisted_11 = { class: "opacity-80 ml-2" }
const _hoisted_12 = { class: "ml-4" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "ml-2" }
const _hoisted_15 = { class: "py-6 w-1/6 mx-4 flex flex-col items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString($data.answersNumber), 1),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_link, {
        to: { name: 'Question', params: { qId: $data.id, 'user_id': $data.currentUserId } }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "text-2xl font-semibold cursor-pointer",
            dir: $data.language === 'en' ? 'ltr' : 'rtl',
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.handlePageRouting()))
          }, _toDisplayString($data.text), 9, _hoisted_5)
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              class: "w-6 h-6",
              src: $data.userImg || _ctx.$store.state?.alternativeImg,
              alt: "profile pic"
            }, null, 8, _hoisted_9)
          ]),
          _createVNode(_component_router_link, {
            to: { name: 'Profile', params: { 'user_id': ($data.owner.universityId || 0) } },
            class: "flex"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, _toDisplayString($data.owner.name), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_11, _toDisplayString($data.time), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            class: "cursor-pointer",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.toggleLike && $options.toggleLike(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: "thumbs-up",
              style: _normalizeStyle({ color: $data.currentLikeColor })
            }, null, 8, ["style"])
          ]),
          _createElementVNode("div", _hoisted_14, _toDisplayString($data.likes) + " Likes", 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_router_link, {
        to: { name: 'Question', params: { qId: $data.id, 'user_id': $data.currentUserId } }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_the_button, {
            content: "Answer",
            type: "secondary",
            size: "small",
            onClick: $options.handleAnswerClick
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", {
        class: "mt-2 bg-gray-100 w-8 h-8 flex items-center justify-center rounded-full shadow-md cursor-pointer",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.toggleBookmark && $options.toggleBookmark(...args)))
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "bookmark",
          style: _normalizeStyle({ color: $data.currentBookmarkColor })
        }, null, 8, ["style"])
      ])
    ])
  ]))
}